import state from './state';
import { IGetters } from '@/models/store/state.interface';

const getters: IGetters = {
	activeDashboards: () => {
		return state.availableDashboards.filter(dashboard => dashboard.active);
	},
	availableDashboards: () => {
		return state.availableDashboards;
	},
	inactiveDashboards: () => {
		return state.availableDashboards.filter(dashboard => !dashboard.active);
	},
	loadingStateDashboards: () => {
		return state.loadingStateDashboards;
	},
	modalDashboardPreviewState: () => {
		return state.modalDashboardPreviewState;
	},
	modalErrorState: () => {
		return state.modalErrorState;
	},
	router: () => {
		return state.router;
	},
	standAloneLogin: () => {
		return state.standAloneLogin;
	},
	tableauJWT: () => {
		return state.tableauJWT;
	},
	tracker: () => {
		return state.tracker;
	}
};

export default getters;
